import { defineStore } from "pinia";
import { toast } from "@/utils/toast";
import loanRepaymentsService from "@/services/hrm/loan-repayments.service";

const errMsg = (e) =>
  e?.response?.data?.message || e?.message || "Unexpected error";

export const useLoanRepaymentsStore = defineStore("loanRepayments", {
  state: () => ({
    rows: [],
    total: 0,
    pageSize: 50,
    current: 1,
    loading: false,
    lastParams: {},
  }),

  actions: {
    async fetch(params = {}) {
      this.loading = true;
      this.lastParams = { ...params };
      try {
        const { data } = await loanRepaymentsService.list(params);

        if (Array.isArray(data)) {
          this.rows = data;
          this.total = data.length;
          this.pageSize = params.per_page || 50;
          this.current = params.page || 1;
        } else {
          this.rows = data.data || [];
          this.total = data.total || 0;
          this.pageSize = data.per_page || params.per_page || 50;
          this.current = data.current_page || params.page || 1;
        }

        return data;
      } catch (e) {
        toast(errMsg(e), "error");
        throw e;
      } finally {
        this.loading = false;
      }
    },

    async refresh() {
      return this.fetch(this.lastParams || {});
    },
  },
});
